import { Box, LinearProgress } from "@mui/material";
import { progressBarStyle, progressLabelStyle, progressBoxStyle } from "./styles";

export const ProgressBar = ({ percentage }: { percentage: number }) => (
  <Box sx={progressBoxStyle}>
    <LinearProgress variant="determinate" value={percentage} sx={progressBarStyle} />
    <Box sx={progressLabelStyle}>{percentage}%</Box>
  </Box>
);
